import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CondominiumClaimMetadata} from '../condominium-claim-metadata/condominium-claim-metadata';
import {ClaimFileUploads, FileUploadConfig, UploadingStatus} from '../claim-file-uploads/claim-file-uploads';
import {ClaimMetadataRequest} from '../../entity/metadata';
import {ClaimCreatorService} from '../../control/claim-creator-service';
import {ClaimItem, ObjectType} from '../../entity/claim-item';
import {SubmittedClaimOverview} from '../submitted-claim-overview/submitted-claim-overview';
import {ClaimFileType} from '../../entity/claim-file';
import {LocalizationPipePipe} from '../../../localization/control/localisation-pipe-pipe';
import {ActivatedRoute} from '@angular/router';
import {EntireBuildingClaimMetadata} from '../entire-building-claim-metadata/entire-building-claim-metadata';
import {OthersClaimMetadata} from '../others-claim-metadata/others-claim-metadata.component';

export type ClaimWizardStep = 'metadata' | 'quote' | 'photos' | 'submitted';

@Component({
  selector: 'app-claim-wizard',
  templateUrl: './claim-wizard.html',
  imports: [
    CommonModule,
    CondominiumClaimMetadata,
    ClaimFileUploads,
    SubmittedClaimOverview,
    LocalizationPipePipe,
    EntireBuildingClaimMetadata,
    OthersClaimMetadata
  ],
  styleUrl: './claim-wizard.scss'
})
export class ClaimWizard implements OnInit {
  protected readonly photosDocumentsConfig: FileUploadConfig = {
    title: 'Photos/Documents',
    subtitle: 'Please upload photos/deed/layouts/...',
    icon: 'camera_alt',
    multiple: true,
    acceptedTypes: ['JPG', 'JPEG', 'PNG', 'PDF', 'TIFF', 'WEBP', 'HEIC', 'JFIF', 'BMP'],
    maxSize: 'max. 5MB per file',
    dropzoneText: 'Select multiple files',
    optional: false,
    actionName: 'Upload and Submit',
    claimFileType: ClaimFileType.Others
  };
  private readonly steps: ClaimWizardStep[] = ['metadata', 'photos', 'submitted'];

  private step: number = 0;
  protected claimId?: string
  protected claimMetadata?: ClaimMetadataRequest | ClaimItem;
  protected adjustmentMethod: string = "photos only"
  objectType: ObjectType = ObjectType.CondominiumUnit;

  get wizardState(): ClaimWizardStep {
    const step = Math.min(this.step, this.steps.length - 1)
    return this.steps[step];
  };

  constructor(
    protected readonly claimService: ClaimCreatorService,
    private cdr: ChangeDetectorRef,
    private readonly activeRoute: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.claimId = undefined
    this.step = 0;
    this.claimMetadata = undefined
    this.activeRoute.params.subscribe(params => {
        switch ((params['type'] ?? '')) {
          case 'entireBuilding':
          case ObjectType.Residence: {
            this.objectType = ObjectType.Residence
            break;
          }
          case 'others':
          case ObjectType.Others: {
            this.objectType = ObjectType.Others
            break;
          }
          default: {
            this.objectType = ObjectType.CondominiumUnit
          }
        }
      }
    )
  }

  onPhotosFileUploaded($event: UploadingStatus) {
    if ($event?.status === 'completed') {
      this.claimService.submitClaim(this.claimId!, this.adjustmentMethod).then(r => {
        this.nextStep();
      })
    }
  }

  afterClaimInitiation($event: ClaimMetadataRequest) {
    console.log('afterClaimCreation', $event)
    this.claimId = $event.claimID
    this.claimMetadata = $event;
    setTimeout(() => this.nextStep(), 0)
  }


  private nextStep() {
    console.log('current step', this.wizardState)
    this.step = Math.min(this.step + 1, this.steps.length - 1)
    this.cdr.detectChanges()
    console.log('next step', this.wizardState)
  }

  protected readonly ObjectType = ObjectType;
}
